'use client'

import {useUser} from '@fitro/customer-host/auth'
import {useCustomerScrollScope} from './CustomerScrollRestorationProvider'

/** Auth stays inside the existing host provider; public-only routes do not load it. */
export function CustomerAuthenticatedScrollScope() {
    const {user, isLoaded} = useUser()
    const host = typeof window === 'undefined' ? '' : window.location.host
    useCustomerScrollScope(user ? `customer:${host}:${user.id}` : `customer-public:${host}`, isLoaded)
    return null
}
